/* eslint-disable @typescript-eslint/naming-convention */
declare global {
  interface Window {
    Shopify: {
      analytics: {
        publish: (event: string, data: Record<string, unknown>) => void
      }
    }
    dataLayer: unknown[]
  }
}

interface GTMEventData {
  items?: unknown[]
  item_list_name?: string
  clic_cta?: string
  href?: string
  menu_element?: string
  link_name?: string
}

export function init() {
  const ctas = document.querySelectorAll('a[data-tag],button[data-tag],a[data-item]')
  ctas.forEach((cta) => {
    cta.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLElement
      const item = target.dataset.item
      const tag = target.dataset.tag

      const o: GTMEventData = {}
      let event = 'cta_clicked'

      if (item) {
        o.items = [JSON.parse(item)]
        if (target.dataset.list) o.item_list_name = target.dataset.list

        event = 'item_selected'
      } else if (tag) {
        o.clic_cta = tag

        const menu_element = target.dataset.menu
        if (tag === 'menu_nav' && menu_element) o.menu_element = menu_element

        if ('href' in target && typeof target.href === 'string') {
          const linkUrl = new URL(target.href)
          if (linkUrl.origin !== window.location.origin) {
            o.link_name = target.href
          }
        }

        event = 'clic_cta'
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event,
          ...o
        })
      }
    })
  })
}
